import React, { useEffect, useState } from 'react';
import ApiService from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getUserId } from '../../../../../Redux/selecters';
import GiftCardGrid from './giftCardGrid'; // adjust path if different
import { initial } from 'lodash';
import moment from 'moment';

// ✅ IMPORTANT:
// Your project already uses these:
const GET_ALL_ENDPOINT = 'GET_ALL_GIFT_CARDS';

// ✅ Change this if your backend uses a different key
// examples: "CREATE_GIFT_CARD" or "ADD_GIFT_CARD" etc.
const CREATE_ENDPOINT = 'CREATE_GIFT_CARD';

const GiftCardMaster = ({ Currency }) => {
  const UserId = useSelector(getUserId);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [giftCards, setGiftCards] = useState([]);

  const [formData, setFormData] = useState({
    itemDescription: '',
    initialAmount: '',
  });

  const fetchGiftCards = async () => {
    setLoading(true);
    try {
      const apiService = new ApiService();
      const res = await apiService.get(GET_ALL_ENDPOINT);
      const list = res?.data?.result ?? res?.data?.data ?? res?.data ?? [];
      setGiftCards(Array.isArray(list) ? list : []);
    } catch (e) {
      console.error(e);
      toast.error('Failed to load gift cards');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGiftCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const validate = () => {
    if (!formData.itemDescription?.trim()) return toast.warning('Enter Item Description'), false;
    if (formData.initialAmount === '' || isNaN(Number(formData.initialAmount))) return toast.warning('Enter a valid Initial Amount'), false;
    if (Number(formData.initialAmount) < 0) return toast.warning('Amount must be > 0'), false;
    return true;
  };

  const handleCreate = async () => {
    if (!validate()) return;

    setSaving(true);
    try {
      if (formData.initialAmount < 0) {
        toast.warning('Initial Amount cannot be negative');
        setSaving(false);
        return;
      }
      const datareq = {
        loggedInUserId: UserId,

        // ✅ visible fields
        itemDescription: formData.itemDescription.trim(),
        initialAmount: Number(formData.initialAmount),

        // ✅ hidden fields (send NULL as you requested)
        currencyCode: Currency?.Currency?.code,
        issuedDate: moment(Date.now()).format(),
        isReloadable: true,
        isDigital: true,

        // ✅ if your backend has expiryDate and you want it null too
        expiryDate: null,
      };

      const apiService = new ApiService();
      const res = await apiService.post(CREATE_ENDPOINT, datareq);

      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
        toast.success('Gift Card Created Successfully');

        // reset form
        setFormData({ itemDescription: '', initialAmount: '' });

        // refresh list
        fetchGiftCards();
      } else {
        toast.warning(res?.data?.message ?? 'Waiting for Response');
      }
    } catch (e) {
      console.error(e);
      toast.error('Create failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-lg-5 container">
      <div className="row catlist">
        <h5 className="mb-3">Gift Card Master</h5>

        {/* ✅ CREATE FORM (only 2 fields shown) */}
        <div className="form-group row mt-2">
          <div className="col-md-8 mt-2">
            <label className="form-label"> Giftcard Name</label>
            <input
              type="text"
              className="p-2 form-control"
              name="itemDescription"
              value={formData.itemDescription}
              onChange={handleChange}
              placeholder="e.g. Festival Gift Card"
            />
          </div>

          <div className="col-md-3 mt-3">
            <label className="form-label">Initial Amount</label>
            <input
              type="number"
              className="p-2 form-control"
              name="initialAmount"
              value={formData.initialAmount}
              onChange={handleChange}
              min="0"
              step="0.01"
              placeholder="e.g. 100"
            />
          </div>

          {/* ✅ NOT SHOWN TO USER:
              currencyCode, issuedDate, isReloadable, isDigital, expiryDate
              ✅ but sent as NULL in handleCreate()
          */}
        </div>

        <div className="row justify-content-end mt-4">
          <button className="col-lg-2 col-md-3 addItem-btn p-3 mt-4 mb-3 mx-3" onClick={handleCreate} disabled={saving} type="button">
            {saving ? 'Saving...' : 'Create Gift Card'}
          </button>
        </div>

        <hr />

        {/* ✅ LIST */}
        {loading ? <div className="p-3">Loading...</div> : <GiftCardGrid giftCards={giftCards} />}
      </div>
    </div>
  );
};

export default GiftCardMaster;
